import { template as template_852f1091b2364b788eed6a42699eac83 } from "@ember/template-compiler";
import PendingInsuranceInfoBanner from './pending-insurance-info-banner';
import RejectedRequests from './rejected-requests';
import styles from './submission-notifications.module.scss';
export default template_852f1091b2364b788eed6a42699eac83(`
  <div class={{styles.component}}>
    {{#if @pendingInsuranceRequests}}
      <PendingInsuranceInfoBanner @pendingInsuranceInfoCount={{@pendingInsuranceRequests.length}} />
    {{/if}}
    {{#if @rejectedInsuranceRequests}}
      <RejectedRequests @rejectedInsuranceRequests={{@rejectedInsuranceRequests}} />
    {{/if}}
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
